const BASE_URL =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
  "";

export async function postDeepAnalysisV2(data) {
  const res = await fetch(`${BASE_URL}/deep-analysis-v2`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
}

export async function postDemandGrid(data) {
  const res = await fetch(`${BASE_URL}/demand-grid`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
}

// Pro city-wide scored grid (100m or 1km choropleth). Used by Analysis and by
// Branch Radar's optional "site-score" overlay layer for the selected city.
export async function postProScoredGrids(kodeKabkot, body = {}) {
  const res = await fetch(`${BASE_URL}/api/pro/scored-grids/${encodeURIComponent(kodeKabkot)}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  return res.json();
}
